import * as DOMPurify from 'dompurify';

const isHtml = new RegExp(/(<([^>]+)>)/i);

const Html = (props) => {
  const childIsHtmlString = isHtml.test(props.children);

  const config = {
    ADD_ATTR: ['target'],  
    ALLOWED_ATTR: ['href', 'target', 'class', 'id'], 
  };

  const purified = DOMPurify.default.sanitize(props.children, config);
  return (<>
    { childIsHtmlString ? <div className={props.className} dangerouslySetInnerHTML={{ __html: purified }} /> : <p className={props.className} >{props.children}</p> }
  </>);
}

export default Html;
